import MainLayout from '@/app/ui/layouts/Main/index.vue'
import BACKEND_SLUG from '@/app/ui/router/constants'
import { RouteConfig } from 'vue-router'

export const dropBox: RouteConfig = {
  path: '/drop-box',
  component: MainLayout,
  meta: {
    title: 'Drop Box',
    single: false,
    icon: 'MenuIconDropBox',
  },
  children: [
    // Drop Box Monitoring (first sub-menu)
    {
      path: 'monitoring',
      name: 'DropBoxMonitoringPage',
      component: () =>
        import(
          /* webpackChunkName: "DropBoxMonitoringPage" */ '@/app/ui/views/DropBox/Monitoring/index.vue'
        ),
      meta: {
        title: 'Drop Box Monitoring',
        slugFromBackend: BACKEND_SLUG.DROP_BOX_MONITORING,
        accessType: 'read',
      },
    },
    // Drop Box List (second sub-menu)
    {
      path: '',
      name: 'DropBoxListPage',
      component: () =>
        import(
          /* webpackChunkName: "DropBoxListPage" */ '@/app/ui/views/DropBox/index.vue'
        ),
      meta: {
        title: 'Drop Box List',
        slugFromBackend: BACKEND_SLUG.DROP_BOX,
        accessType: 'read',
      },
    },
    {
      path: 'create',
      name: 'CreateDropBoxPage',
      component: () =>
        import(
          /* webpackChunkName: "CreateDropBoxPage" */ '@/app/ui/views/DropBox/Create/index.vue'
        ),
      meta: {
        title: 'Create Drop Box',
        slugFromBackend: BACKEND_SLUG.DROP_BOX,
        accessType: 'write',
        isHidden: true,
      },
    },
    {
      path: ':id',
      name: 'DropBoxDetailPage',
      component: () =>
        import(
          /* webpackChunkName: "DropBoxDetailPage" */ '@/app/ui/views/DropBox/Detail/index.vue'
        ),
      meta: {
        title: 'Detail Drop Box',
        slugFromBackend: BACKEND_SLUG.DROP_BOX,
        accessType: 'read',
        isHidden: true,
      },
    },
    {
      path: 'edit/:externalId',
      name: 'EditDropBoxPage',
      component: () =>
        import(
          /* webpackChunkName: "EditDropBoxPage" */ '@/app/ui/views/DropBox/Edit/index.vue'
        ),
      meta: {
        title: 'Edit Drop Box',
        slugFromBackend: BACKEND_SLUG.DROP_BOX,
        accessType: 'write',
        isHidden: true,
      },
    },
  ],
}
